import React, { useState } from 'react';

const inputStyle = {
  width: '100%', padding: '14px 16px', border: '1px solid #e8e8e8',
  fontSize: '14px', transition: 'all 0.3s ease', outline: 'none', fontFamily: 'inherit'
};
const labelStyle = {
  display: 'block', fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px',
  textTransform: 'uppercase', color: '#333', marginBottom: '10px'
};
const buttonStyle = {
  padding: '14px 32px', border: '2px solid #333', background: '#333',
  color: '#fff', fontSize: '11px', fontWeight: '700', letterSpacing: '2px',
  textTransform: 'uppercase', cursor: 'pointer', transition: 'all 0.3s ease'
};

const ProjectRegistration = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const emptyForm = {
    company_name: '', contact_first_name: '', contact_last_name: '',
    contact_email: '', project_category: '', project_title: '',
    target_audience: '', source_materials: '', submission_date: '',
    project_goal: '', visual_references: '', deliverables: '',
    desired_deadline: '', terms_confirm: false
  };
  const [formData, setFormData] = useState(emptyForm);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleNext = () => setCurrentStep(prev => Math.min(prev + 1, 4));
  const handlePrevious = () => setCurrentStep(prev => Math.max(prev - 1, 1));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const msg = [
        'PROJECT REGISTRATION DETAILS',
        '=============================',
        `Company/Client Name: ${formData.company_name}`,
        `Contact Name: ${formData.contact_first_name} ${formData.contact_last_name}`,
        `Email: ${formData.contact_email}`,
        '',
        `Category: ${formData.project_category}`,
        `Project Title: ${formData.project_title}`,
        `Music Preferred: ${formData.target_audience}`,
        `Source Materials: ${formData.source_materials}`,
        `Date Created: ${formData.submission_date}`,
        '',
        `Total File Size: ${formData.project_goal}`,
        `Style References: ${formData.visual_references || 'Not provided'}`,
        `Additional Details: ${formData.deliverables || 'Not specified'}`,
        `Desired Deadline: ${formData.desired_deadline || 'Not specified'}`,
        '',
        `Submitted: ${new Date().toLocaleString()}`
      ].join('\n');

      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: '699e1a25-c648-4bc9-9513-1b5dcea93339',
          subject: `New Project Registration - ${formData.company_name}`,
          from_name: `${formData.contact_first_name} ${formData.contact_last_name}`,
          email: formData.contact_email,
          message: msg,
        })
      });
      const result = await res.json();
      if (result.success) {
        alert('Thank you! Your creative brief has been submitted. We will review it and get back to you within one business day.');
        setFormData(emptyForm);
        setCurrentStep(1);
      } else {
        alert('There was an error submitting your brief. Please try again or email us directly at info@themidnightedits.com');
      }
    } catch (err) {
      console.error('Error:', err);
      alert('There was an error submitting your brief. Please email us directly at info@themidnightedits.com');
    }
  };

  const fi = (name, label, type = 'text', placeholder = '', required = false, extra = {}) => (
    <div style={{ marginBottom: '25px' }}>
      <label htmlFor={name} style={labelStyle}>{label}{required ? ' *' : ''}</label>
      <input
        type={type} id={name} name={name} placeholder={placeholder}
        value={formData[name]} onChange={handleChange} required={required}
        style={inputStyle}
        onFocus={(e) => e.target.style.borderColor = '#d4af37'}
        onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}
        {...extra}
      />
    </div>
  );

  const ta = (name, label, placeholder, required = false, rows = 3) => (
    <div style={{ marginBottom: '25px' }}>
      <label htmlFor={name} style={labelStyle}>{label}{required ? ' *' : ''}</label>
      <textarea
        id={name} name={name} rows={rows} placeholder={placeholder}
        value={formData[name]} onChange={handleChange} required={required}
        style={{ ...inputStyle, resize: 'vertical' }}
        onFocus={(e) => e.target.style.borderColor = '#d4af37'}
        onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}
      />
    </div>
  );

  return (
    <section id="project-registration" style={{ background: '#fff', padding: '80px 0' }}>
      <div className="container">
        <div className="sixteen columns">
          <div className="section-top">
            <div className="line-dark"></div>
            <h1>project registration</h1>
            <div className="subtext-top">Submit Your Creative Brief</div>
            <div className="line-dark1"></div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '800px', margin: '60px auto', padding: '0 20px' }}>
        {/* Progress Indicator */}
        <div style={{ marginBottom: '50px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
            {[1, 2, 3, 4].map(step => (
              <div key={step} style={{ flex: 1, textAlign: 'center' }}>
                <div style={{
                  width: '40px', height: '40px', borderRadius: '50%', margin: '0 auto',
                  background: currentStep >= step ? '#d4af37' : '#e8e8e8',
                  color: currentStep >= step ? '#fff' : '#999',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '14px', fontWeight: '700', transition: 'all 0.3s ease'
                }}>{step}</div>
                <div style={{
                  fontSize: '10px', fontWeight: '700', letterSpacing: '1px',
                  textTransform: 'uppercase', marginTop: '10px',
                  color: currentStep >= step ? '#d4af37' : '#999'
                }}>
                  {['Contact', 'Project', 'Details', 'Review'][step - 1]}
                </div>
              </div>
            ))}
          </div>
          <div style={{ height: '2px', background: '#e8e8e8', position: 'relative', top: '-50px', zIndex: -1 }}>
            <div style={{
              height: '2px', background: '#d4af37',
              width: `${((currentStep - 1) / 3) * 100}%`, transition: 'width 0.3s ease'
            }} />
          </div>
        </div>

        <div style={{
          background: '#fff', padding: '50px', minHeight: '500px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '1px solid #e8e8e8'
        }}>
          <form onSubmit={handleSubmit}>

            {/* Step 1 */}
            {currentStep === 1 && (
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#333', marginBottom: '30px' }}>
                  Your Contact Information
                </h3>
                {fi('company_name', 'Company / Client Name', 'text', '', true)}
                <div style={{ marginBottom: '25px' }}>
                  <label style={labelStyle}>Primary Contact Name *</label>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <input type="text" name="contact_first_name" placeholder="First Name"
                      value={formData.contact_first_name} onChange={handleChange} required
                      style={inputStyle}
                      onFocus={(e) => e.target.style.borderColor = '#d4af37'}
                      onBlur={(e) => e.target.style.borderColor = '#e8e8e8'} />
                    <input type="text" name="contact_last_name" placeholder="Last Name"
                      value={formData.contact_last_name} onChange={handleChange} required
                      style={inputStyle}
                      onFocus={(e) => e.target.style.borderColor = '#d4af37'}
                      onBlur={(e) => e.target.style.borderColor = '#e8e8e8'} />
                  </div>
                </div>
                {fi('contact_email', 'Email Address', 'email', 'project@yourcompany.com', true)}
              </div>
            )}

            {/* Step 2 */}
            {currentStep === 2 && (
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#333', marginBottom: '30px' }}>
                  Project Scope &amp; Requirements
                </h3>
                <div style={{ marginBottom: '25px' }}>
                  <label htmlFor="project_category" style={labelStyle}>Project Category *</label>
                  <select id="project_category" name="project_category"
                    value={formData.project_category} onChange={handleChange} required
                    style={{ ...inputStyle, cursor: 'pointer' }}
                    onFocus={(e) => e.target.style.borderColor = '#d4af37'}
                    onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}>
                    <option value="">Select Category...</option>
                    <option value="Wedding Highlight Film">Wedding Highlight Film</option>
                    <option value="Wedding Feature Film">Wedding Feature Film</option>
                    <option value="Wedding Highlight and Feature Film">Wedding Highlight and Feature Film</option>
                    <option value="Others">Others</option>
                  </select>
                </div>
                {fi('project_title', 'Project Working Title (Couple Name)', 'text', 'e.g., "Emily & Daniel"')}
                {fi('target_audience', 'Music Preferred', 'text', 'Music name or link', true)}
                {ta('source_materials', 'Source Materials Links', 'Paste Dropbox, Drive links here', true)}
                {fi('submission_date', 'Date Created', 'date', '', true)}
              </div>
            )}

            {/* Step 3 */}
            {currentStep === 3 && (
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#333', marginBottom: '30px' }}>
                  Creative Direction &amp; Output
                </h3>
                {ta('project_goal', 'Total File Size', 'e.g., 5GB, 25GB, 50GB etc.', true)}
                {fi('visual_references', 'Style References (optional)', 'url', 'Pinterest, YouTube links')}
                {ta('deliverables', 'Additional Details', 'e.g., any specific requests')}
                {fi('desired_deadline', 'Desired Deadline', 'date')}
              </div>
            )}

            {/* Step 4 */}
            {currentStep === 4 && (
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#333', marginBottom: '30px' }}>
                  Review &amp; Submit
                </h3>
                <div style={{ background: '#f8f9fa', padding: '25px', marginBottom: '30px', border: '1px solid #e8e8e8' }}>
                  <h4 style={{ fontSize: '12px', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: '#d4af37', marginBottom: '15px' }}>Our Process</h4>
                  {['Review within one business day', 'Watermarked preview for feedback', 'Final delivery after approval'].map((t, i) => (
                    <p key={i} style={{ fontSize: '13px', color: '#666', lineHeight: '1.8', marginBottom: i < 2 ? '10px' : 0 }}>✓ {t}</p>
                  ))}
                </div>
                <div style={{ marginBottom: '30px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '13px', color: '#666' }}>
                    <input type="checkbox" name="terms_confirm" checked={formData.terms_confirm}
                      onChange={handleChange} required
                      style={{ marginRight: '12px', width: '18px', height: '18px', cursor: 'pointer' }} />
                    I confirm the information is accurate and complete *
                  </label>
                </div>
              </div>
            )}

            {/* Navigation */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '40px', paddingTop: '30px', borderTop: '1px solid #e8e8e8' }}>
              {currentStep > 1 && (
                <button type="button" onClick={handlePrevious} style={buttonStyle}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#333'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = '#333'; e.currentTarget.style.color = '#fff'; }}>
                  ← Previous
                </button>
              )}
              {currentStep < 4 ? (
                <button type="button" onClick={handleNext}
                  style={{ ...buttonStyle, marginLeft: 'auto', border: '2px solid #d4af37', background: '#d4af37' }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#d4af37'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = '#d4af37'; e.currentTarget.style.color = '#fff'; }}>
                  Next →
                </button>
              ) : (
                <button type="submit"
                  style={{ ...buttonStyle, marginLeft: 'auto', border: '2px solid #d4af37', background: '#d4af37' }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#d4af37'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = '#d4af37'; e.currentTarget.style.color = '#fff'; }}>
                  Submit Brief
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ProjectRegistration;
